import Rectangle1 from "../../assets/images/dashboard-2/rectangle-26.png";
import Rectangle2 from "../../assets/images/dashboard-2/rectangle-27.png";
import Rectangle3 from "../../assets/images/dashboard-2/rectangle-28.png";
import Rectangle4 from "../../assets/images/dashboard-2/rectangle-29.png";

export const HotsellingData = [
  {
    id: 1,
    img: Rectangle1,
    title: "Dominoes Coffee Table Game",
    sales: "60k Sales",
    prize: "$50",
  },
  {
    id: 2,
    img: Rectangle2,
    title: "Photive Wireless speakers",
    sales: "35k Sales",
    prize: "$25",
  },
  {
    id: 3,
    img: Rectangle3,
    title: "Urbanears Lotsen Speaker",
    sales: "53k Sales",
    prize: "$30",
  },
  {
    id: 4,
    img: Rectangle4,
    title: "Plattan 2 Headphones",
    sales: "35k Sales",
    prize: "$45",
  },
];

export const TableRowData = [
  {
    id: 1,
    divClass: "round-light icon-secondary",
    Icons: "fa fa-trophy font-primary",
    title: "Win best seller of the year award",
    place: "Company,San Francisco",
    time: "1 day ago",
  },
  {
    id: 2,
    divClass: "round-light icon-primary",
    Icons: "fa fa-check-circle font-secondary",
    title: "Approved our product in checking",
    place: "Elisse Joson,San Francisco",
    time: "2 weeks ago",
  },
  {
    id: 3,
    divClass: "round-light icon-success",
    Icons: "fa fa-bookmark font-success",
    title: "Win best seller of the year award",
    place: "Company,San Francisco",
    time: "3 day ago",
  },
  {
    id: 4,
    divClass: "round-light icon-warning",
    Icons: "fa fa-shopping-basket font-warning",
    title: "Approved our product in checking",
    place: "35k Sales",
    time: "2 hour ago",
  },
];
